import React, { Component } from 'react';
import axios from 'axios';
import sanitizeHtml from 'sanitize-html';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import { Jumbotron, Hero } from '@/components/styles/JumbotronStyles';
import { IncomeTaxesStyles } from '@/components/IncomeTaxes/IncomeTaxesStyles';
import { WordPressAPI } from '../../config';
import AuditFeaturesComponent from '@/components/AuditFeaturesComponent/AuditFeaturesComponent';
import LearnMoreBlogs from "@/components/LearnMoreBlogs";
import FooterComponent from '@/components/Footer/FooterComponent';
import Header from '@/components/Header/Header';
import SEOHead from '@/components/SEOHead/SEOHead';
import validatePaidCampaign from '@helpers/validatePaidCampaign';
import { ReactSVG } from 'react-svg'
import parse from 'html-react-parser';
import FaqComponent from '@/components/Bookkeeping/FaqComponent';

const PullUpScheduler = dynamic(() =>
  import('@/components/PullUpScheduler/PullUpSchedulerV2')
);

const AboutServiceComponent = dynamic(
  () => import('@components/AboutService/AboutServiceComponent'),
  { ssr: false }
);

const TrustPilotComponent = dynamic(
  () => import('@/components/TrustPilot/TrustPilotComponent'),
  { ssr: false }
);

const CTAListComponent = dynamic(
  () => import('@components/Bookkeeping/CTAListComponent'),
  { ssr: false }
);

const FooterNewsModal = dynamic(import('@/components/FooterNewsModal'));


const TPStyles = styled.div`
background-color: #F5F5F7;
padding: 20px 0px;
position: relative;

.tp-container {
  margin: 0 auto;
  max-width: 100%;
  
  ${props => props.theme.media.md} {
    margin-top: 10px;
    max-width: 67%;
  }
}
`;

class TaxPreparation extends Component {
  state = {
    isSchedulerOpen: false,
    PaidCampaign: 1,
    hideSchedulerHeader: false,
  };

  componentDidUpdate() {
    if (this.state.isSchedulerOpen) {
      document.body.classList.add('no-overflow');
    } else {
      document.body.classList.remove('no-overflow');
    }
  }

  toggleIsSchedulerOpen = () => {
    this.setState(prevState => ({
      isSchedulerOpen: !prevState.isSchedulerOpen,
      hideSchedulerHeader: !prevState.isSchedulerOpen,
    }));
  };

  render() {
    const { data, blogModuleData } = this.props;
    const { title, acf } = this.props.data;
    const paid_campaign = validatePaidCampaign(acf.paid_campaign);
    const additional_questions = acf.additional_questions;

    //One field for both about services sections
    const aboutServices1 = acf.about_services.slice(0, 3);
    const aboutServices2 = acf.about_services.slice(3);

    const sanitizeSettings = {
      allowedTags: ['p', 'h2', 'strong', 'span'],
      allowedAttributes: {
        p: [''],
      },
    };

    // not a field in WP
    const happySubtitle = 'We have certified income tax service experts in every state. Our Enrolled Agents (EAs), Certified Public Accountants (CPAs), accountants, and other tax professionals organize your income and expenses so you can qualify for every possible deduction.';
    //Unable to update in WP
    const section_subtitle = "Learn about taxes, bookkeeping tips, and how to grow your small business.";

    //customClasses
    const customClass = 'income-taxes';
    // 1st about services section
    const customClass1 = 'income-taxes-1';
    //2nd about services section
    const customClass2 = 'income-taxes-2';

    return (
      <IncomeTaxesStyles>
        <SEOHead>
          <title>{acf?.page_title_tag}</title>
          <meta
            name="description"
            content={acf?.meta_description || ''}
            key="description"
          />
          <script
            type="text/javascript"
            src="//app-ab33.marketo.com/js/forms2/js/forms2.min.js"
          />
          {parse(`<script type="application/ld+json">
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [{
                "@type": "Question",
                "name": "Do you file business and personal taxes together?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "LLCs taxed as a partnership or S corporation are pass-through entities but file separate tax returns. The difference is the partnership and S corporation file a tax return to show income, expenses, and what percentage of the profits each partner owns, which then flows onto the partner's personal tax return."
                }
              },{
                "@type": "Question",
                "name": "How do business losses affect personal taxes?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Generally, you're able to reduce your taxable income by writing off business losses. 
            But not all business loss reduces taxable income. For instance, if your business is not operational as yet, but incurs a loss, the deduction is typically disallowed until the business becomes operational."
                }
              }]
            }
            </script>
          `)}
        </SEOHead>
        <Header
          AdditionalQuestions={additional_questions}
          PaidCampaign={paid_campaign}
          phone_number={acf.phone_number_setup}
          leadValues={acf.lead_values}
          hideSchedulerHeader={this.state.hideSchedulerHeader}
        />
        <Jumbotron background={data.acf.hero_background_image.url} className="jumbotron">
          <div className="income-taxes-header">
            <Hero>
              <div className="container">
                <h1>{acf.hero_title}</h1>
                <div
                  className="sub-header"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(acf.hero_sub_title, {
                      allowedTags: ['p'],
                    }),
                  }}
                />
                <div className={`btn-wrap mb-lg-5`}>
                  <button className="btn btn-hero-cta" type="button" onClick={this.toggleIsSchedulerOpen}>
                    Schedule My Free Call
                    <ReactSVG className="btn-icon" src="/icons/calendar-check.svg" />
                  </button>
                </div>
              </div>
            </Hero>
          </div>
        </Jumbotron>
        <div className="trust-pilot-container">
          <TPStyles>
            <div className="tp-container">
              <TrustPilotComponent
                templateID="5406e65db0d04a09e042d5fc"
                height="75px"
                alt
              />
            </div>
          </TPStyles>
        </div>
        <AuditFeaturesComponent
          title={acf.section_title}
          subtitle={acf.section_subtitle}
          features={acf.section}
          customClass={customClass}
        />
        <section className="about-services">
          {aboutServices1.map((item, index) => (
            <AboutServiceComponent
              key={index}
              data={item}
              handleScheduler={this.toggleIsSchedulerOpen}
              whiteBg
              showImgs
              customStyle={`${customClass1} index-${index}`}
              wordPressVideo={false}

            />
          ))}
        </section>
        <section className="happy-to-help">
          <div className="happy-title mobile">
            <div>
              {acf.about_services_section_title.slice(0, 4)}
            </div>
            <div>
              {acf.about_services_section_title.slice(4)}
            </div>
          </div>
          <div className="happy-title desktop">{acf.about_services_section_title}</div>
          <div className="happy-subtitle">{happySubtitle}</div>
          {aboutServices2.map((item, index) => (
            <AboutServiceComponent
              key={index}
              data={item}
              handleScheduler={this.toggleIsSchedulerOpen}
              whiteBg
              showImgs
              customStyle={`${customClass2} index-${index}`}
              wordPressVideo={false}

            />
          ))}
        </section>
        <section className="cta-list">
          <CTAListComponent
            title={acf.cta_list.title}
            list_text={acf.cta_list.list_text}
            image={acf.cta_list.image}
            handleScheduler={null}
            customClass={customClass}
          />
        </section>

        <section className="faqs">
          <FaqComponent title={acf.faq_title} faqs={acf.q_and_a} />
        </section>

        <section className="learn-more-blogs">
          <LearnMoreBlogs
            blogModuleData={blogModuleData}
            section_subtitle={section_subtitle}
            wwo_section_title={acf.wwo_section_title}
          />
          <div className="text-center">
            <button
              className="btn btn-secondary btn-lg mx-auto"
              type="button"
              onClick={() => {
                this.toggleIsSchedulerOpen();
              }}
            >
              Schedule My Free Call
            </button>
          </div>
        </section>
        {/* Email Newsletter */}
        <FooterNewsModal />
        <FooterComponent phone_number={acf.phone_number_setup} />

        {this.state.isSchedulerOpen && (
          <PullUpScheduler
            setIsSchedulerOpen={this.toggleIsSchedulerOpen}
            leadValues={acf.lead_values}
            PaidCampaign={this.state.PaidCampaign}
            AdditionalQuestions={additional_questions}
          />
        )}
      </IncomeTaxesStyles>
    );
  }
}

export const getStaticProps = async () => {
  const GET_POST_URL = `${process.env.NEXT_PUBLIC_BLOG}/wp-json/wp/v2/posts`;

  const axiosWP = axios.get(`${WordPressAPI.pages}/215`);
  const axiosBlog1 = axios.get(`${GET_POST_URL}?slug=quarterly-estimated-taxes&_embed=true`);
  const axiosBlog2 = axios.get(`${GET_POST_URL}?slug=end-year-tax-checklist&_embed=true`);
  const axiosBlog3 = axios.get(`${GET_POST_URL}?slug=what-is-a-1099&_embed=true`);

  const [{ data }, blogData1, blogData2, blogData3] = await Promise.all([axiosWP, axiosBlog1, axiosBlog2, axiosBlog3]);

  const post1 = blogData1.data[0];
  const post2 = blogData2.data[0];
  const post3 = blogData3.data[0];

  const blogModuleData = [post1, post2, post3];

  return {
    props: {
      data,
      blogModuleData
    },
    // revalidate: 1,
  };
};

export default TaxPreparation;
